import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import error from '../../../img/icons/error.svg';
import { Link } from 'react-router-dom';
import translate from '../../../components/TranslateHOC';
import { IsvgWrapper } from '../../../helpers';

const InvalidDateMessage = ({
  dayLoading,
  validDate,
  formattedDate,
  curLang,
  match,
  todaysDate,
  strings,
}) => {
  if (!dayLoading && !validDate) {
    return (
      <div className="tv-schedule__listings-invalid-date">
        <h3 className="tv-schedule__listings-invalid-date-title">
          <IsvgWrapper>
            <Isvg src={error} />
          </IsvgWrapper>
          {strings.catchUpInValidDate}
        </h3>

        {curLang === 1 && (
          <div>
            Sorry, the data requested ({formattedDate}) falls outside the range
            available.
            <br />
            Please try another date from the menu or try{' '}
            <Link to={`${match.path}/${todaysDate.string}`}>
              today&acute;s programmes
            </Link>
            .
          </div>
        )}

        {curLang === 0 && (
          <div>
            Mae'n ddrwg gennym, mae'r data y gofynnwyd amdano ({formattedDate})
            y tu allan i'r ystod sydd ar gael. Rhowch gynnig ar ddyddiad arall
            o'r ddewislen neu rhowch gynnig ar{' '}
            <Link to={`${match.path}/${todaysDate.string}`}>
              raglenni heddiw
            </Link>
            .
          </div>
        )}
      </div>
    );
  } else {
    return null;
  }
};

InvalidDateMessage.propTypes = {
  dayLoading: PropTypes.bool.isRequired,
  validDate: PropTypes.bool.isRequired,
  formattedDate: PropTypes.string.isRequired,
  curLang: PropTypes.number.isRequired,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  todaysDate: PropTypes.object.isRequired,
  strings: PropTypes.object.isRequired,
};

export default translate(InvalidDateMessage);
